@if (company(); as company) {
  <nav id="navbar" class="bg-background border-border border-b">
    <div class="container mx-auto flex h-14 items-center gap-2 px-3 lg:px-4">
      <!-- Mobile: hamburger + sheet -->
      <div class="lg:hidden">
        <app-mobile-nav
          [company]="company"
          [logoUrl]="companyLogoUrl()"
          (openChange)="onMobileMenuToggle.emit($event)" />
      </div>

      <a routerLink="/" class="flex shrink-0 items-center" aria-label="Zur Startseite">
        <app-logo [widthInPx]="140" [subtitle]="logoSubtitle()" class="hidden lg:block" />
        <img
          src="./assets/icons/icon-384x384.png"
          alt=""
          width="36"
          height="36"
          class="lg:hidden" />
      </a>

      <!-- Desktop navigation -->
      <div class="ml-4 hidden items-center gap-1 lg:flex">
        @for (link of links(); track link.route) {
          <a
            hlmBtn
            variant="ghost"
            [routerLink]="link.route"
            routerLinkActive="bg-accent text-accent-foreground">
            {{ link.label }}
          </a>
        }
      </div>

      <div class="flex flex-1 items-center justify-end gap-2">
        <!-- Sits left of the actions; on mobile the shop button is hidden, so it
             ends up next to "Gutschein einlösen" there (a network has no such button:
             its members redeem). -->
        <app-notification-menu />

        @if (storefrontSuburl()) {
          <button hlmBtn variant="outline" class="hidden lg:inline-flex" (click)="openStorefront()">
            Gutschein-Shop
            <ng-icon name="lucideExternalLink" data-icon="inline-end" />
          </button>
        }

        @if (!company.is_group_admin) {
          <button hlmBtn (click)="navigateToRedeem()">Gutschein einlösen</button>
        }

        <div class="hidden lg:block">
          <app-user-menu [company]="company" />
        </div>
      </div>
    </div>
  </nav>
}
